(() => {
  if (window.houseixElementsMotion) return;
  window.houseixElementsMotion = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggle = document.querySelector('[data-hix-motion-toggle]');
  const progress = document.querySelector('[data-hix-progress]');
  const activeAnimations = new Set();
  let paused = false;
  try { paused = localStorage.getItem('houseix-motion-paused') === 'true'; } catch {}
  const disabled = () => paused || preference.matches;
  const applyPreference = () => {
    document.body.dataset.hixMotion = disabled() ? 'paused' : 'playing';
    if (toggle) {
      toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-pressed', String(paused));
    }
    if (disabled()) activeAnimations.forEach(animation => animation.finish());
  };
  toggle?.addEventListener('click', () => {
    paused = !paused;
    try { localStorage.setItem('houseix-motion-paused', String(paused)); } catch {}
    applyPreference();
  });
  preference.addEventListener('change', applyPreference);
  applyPreference();
  const viewed = new WeakSet();
  const stages = new WeakSet();
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.dataset.offscreen = String(!entry.isIntersecting);
    });
  }, { rootMargin: '80px' });
  const reveal = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal.unobserve(entry.target);
      if (disabled()) return;
      const animation = entry.target.animate([
        { transform: 'translateY(38px)', opacity: .45 },
        { transform: 'translateY(0)', opacity: 1 }
      ], { duration: 850, easing: 'cubic-bezier(.2,.65,.3,1)', delay: Number(entry.target.dataset.hixRevealDelay || 0) });
      activeAnimations.add(animation);
      animation.onfinish = () => activeAnimations.delete(animation);
    });
  }, { threshold: .12 });
  const scan = (root = document) => {
    root.querySelectorAll('[data-hix-elements]').forEach(stage => {
      if (stages.has(stage)) return;
      stages.add(stage);
      visibility.observe(stage);
      const slides = [...stage.querySelectorAll('[data-element-slide]')];
      if (slides.length < 2) return;
      let index = 0;
      const timer = window.setInterval(() => {
        if (!stage.isConnected) { clearInterval(timer); return; }
        if (disabled() || document.hidden || stage.dataset.offscreen === 'true' || document.documentElement.dataset.hixHouse) return;
        const activeIndex = slides.findIndex(slide => slide.classList.contains('is-active'));
        if (activeIndex >= 0) index = activeIndex;
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
        stage.dataset.house = slides[index].dataset.elementSlide;
      }, 6500);
    });
    root.querySelectorAll('#MainContent > .shopify-section, .hix-pieces article, .hix-shop-houses__card, product-card, collection-card').forEach((element, index) => {
      if (viewed.has(element) || element.querySelector('[data-hix-elements]') || element.closest('[data-hix-elements]')) return;
      viewed.add(element);
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.dataset.hixRevealDelay = String(Math.min(index % 4, 3) * 75);
      reveal.observe(element);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', () => scan());
  const main = document.querySelector('#MainContent');
  if (main) {
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; scan(); });
    });
    observer.observe(main, { childList: true, subtree: true });
  }
  let ticking = false;
  const updateProgress = () => {
    const range = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.transform = 'scaleX(' + (range > 0 ? Math.min(1, window.scrollY / range) : 0) + ')';
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (ticking || disabled()) return;
    ticking = true;
    requestAnimationFrame(updateProgress);
  }, { passive: true });
  updateProgress();
})();
